import React from "react"

import { IconType } from "../../dato-components/dato-features-section/types"
import Header from "../../design-system/header"
import Paragraph from "../../design-system/paragraph"
import { IconStaticMap } from "../icon"
import { Color } from "../icon/types"
import * as styles from "./index.module.scss"

interface Props {
  iconType: IconType
  iconColor: Color
  title: string
  description: string
  children?: React.ReactNode
}

function EmptyState({
  title,
  description,
  children,
  iconType,
  iconColor,
  ...rest
}: Props) {
  const Icon = IconStaticMap[iconType]
  return (
    <div className={styles.container} {...rest}>
      <div className={styles.imageContainer}>
        <Icon color={iconColor} highlightAlways />
      </div>
      <Header variant="4" as="h4" className={styles.header}>
        {title}
      </Header>
      <Paragraph variant="2">{description}</Paragraph>
      {children}
    </div>
  )
}

export default EmptyState
